export const ACCOUNT_BUSINESS_STATUS = Object.freeze({
  PUBLIC: 'Public',
  PRIVATE: 'Private',
});
